module.exports = __webpack_public_path__ + "icon_reply-1c00f97d10006dd420bc620b26a79d8a.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/mailer/icon_reply.png
// module id = 278
// module chunks = 88